import Axios from 'axios'
import {residenceTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_residence_types (context) {
    Axios.get(residenceTypeUrls.getAllResidenceTypes).then(function (response) {
      context.commit('GET_ALL_RESIDENCE_TYPES', response.data)
    })
  },
  get_residence_types (context, publicId) {
    Axios.get(residenceTypeUrls.getResidenceType + publicId).then(function (response) {
      context.commit('GET_RESIDENCE_TYPES', response.data)
    })
  },
  get_deleted_residence_types (context) {
    Axios.get(residenceTypeUrls.getDeletedResidenceType).then(function (response) {
      context.commit('GET_DELETED_RESIDENCE_TYPES', response.data)
    })
  },
  get_residence_type (context, publicId) {
    Axios.get(residenceTypeUrls.getResidenceType + publicId).then(function (response) {
      context.commit('GET_RESIDENCE_TYPE', response.data)
    })
  },
  post_residence_type (context, data) {
    Axios.post(residenceTypeUrls.postResidenceType, data).then(function () {
      context.dispatch('get_all_residence_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_residence_type (context, data) {
    Axios.post(residenceTypeUrls.editResidenceType, data).then(function () {
      context.dispatch('get_all_residence_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_residence_type (context, publicId) {
    Axios.get(residenceTypeUrls.deleteResidenceType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_RESIDENCE_TYPES', response.data)
      router.push({
        name: 'Module.DeletedResidenceTypes'
      })
    })
  },
  restoreResidenceType (context, publicId) {
    Axios.get(residenceTypeUrls.restoreResidenceType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_RESIDENCE_TYPES', response.data)
      router.push({
        name: 'Module.ResidenceTypes'
      })
    })
  }
}
